import React from 'react';
import PDPMobilePlaceholder from '../PDPMobilePlaceholder';
import PDPDesktopPlaceholder from '../PDPDesktopPlaceholder';

const PDPPlaceholder = () => (
  <>
    <PDPMobilePlaceholder className="flex lg:hidden" />
    <PDPDesktopPlaceholder className="hidden lg:flex" />
  </>
);

export default PDPPlaceholder;
